import type { Account, ExpenseInput, SavingGoal } from "../../types";

interface EntryGoalFieldsProps {
  input: ExpenseInput;
  account?: Account;
  goals: SavingGoal[];
  onChange: (values: Pick<ExpenseInput, "goalId" | "completeGoal">) => void;
}

export default function EntryGoalFields({ input, account, goals, onChange }: EntryGoalFieldsProps) {
  const selected = goals.find(goal => goal.id === input.goalId);
  const available = goals.filter(goal => goal.id === input.goalId ||
    (goal.status === "active" && !goal.completedDate && goal.currency === account?.currency));
  const canComplete = selected && !selected.completedDate && selected.status !== "archived" && selected.currency === account?.currency;
  return (
    <div className="entry-goal-fields">
      <label>
        Savings goal
        <select aria-label="Savings goal" value={input.goalId || ""}
          onChange={event => onChange({ goalId: event.target.value, completeGoal: false })}>
          <option value="">None (regular spending)</option>
          {available.map(goal => <option key={goal.id} value={goal.id}>{goal.name}</option>)}
        </select>
      </label>
      {canComplete && (
        <label className="entry-goal-completion">
          <span><input type="checkbox" checked={!!input.completeGoal}
            onChange={event => onChange({ goalId: input.goalId, completeGoal: event.target.checked })} />
            This purchase completes the goal</span>
          <small>Finish this goal even if the purchase costs less than the target. Release unused savings and stop monthly saving.</small>
        </label>
      )}
      {selected?.completedDate && <small>Achieved. Monthly saving stopped.</small>}
    </div>
  );
}
